import TableCellChip from "./cell_formats/TableCellChip";
import TableCellCurrency from "./cell_formats/TableCellCurrency";
import TableCellDate from "./cell_formats/TableCellDate";

export default function TableCellFormatter({ type, value, options = {} }) {
  switch (type) {
    case "date":
      return <TableCellDate value={value} options={options} />;
    case "chip":
      return <TableCellChip value={value} options={options} />;
    case "currency":
      return <TableCellCurrency value={value} options={options} />;
    default:
      return <span className={`font-semibold${options.truncate ? " block truncate" : ""}`}>{value ?? "-"}</span>;
  }
}
